export const SIGNATURE_TEXT = "SIGNATURE_TEXT";
export const SIGNATURE_DATA_URL = "SIGNATURE_DATA_URL";
export const SIGNATURE_TEXT_TYPE = "SIGNATURE_TEXT_TYPE";
export const SIGNATURE_ID = "SIGNATURE_ID";
export const ADD_VIEWER_EMAIL = "ADD_VIEWER_EMAIL";
